$(document).ready(function () {
  $(".main-menu li").on("click", function (e) {
    e.stopPropagation();
    $(".main-menu li").removeClass("at-menu");
    $(this).addClass("at-menu");
  });

  $(".main-menu li .menu-item").on("click", function (e) {
    e.stopPropagation();
    $(".main-menu li").removeClass("at-menu");
  });

  $(document).on("click", function (event) {
    $(".main-menu li").removeClass("at-menu");
  });
});
